<template>
  <div id="app">
    <el-dialog
      v-model="$store.state.consultVisible"
      title="立即諮詢"
      fullscreen
      lock-scroll="false"
      center
    >
      <div style="text-align:center;height:60vh">
        <h3>填寫表單，我們會馬上與您聯絡！</h3>
        (建議外連操作：<el-link
          :underline="false"
          type="primary"
          href="https://docs.google.com/forms/d/e/1FAIpQLSfmbCC99oBEyw1OJBlLfaXtd3QdyTt3HosH--K8c57JrWaUew/viewform?embedded=true"
        >
          表單連結
        </el-link>)
        <div style="position: relative;height: 90%;">
          <iframe
            src="https://docs.google.com/forms/d/e/1FAIpQLSfmbCC99oBEyw1OJBlLfaXtd3QdyTt3HosH--K8c57JrWaUew/viewform?embedded=true"
            frameborder="0"
            style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;overflow-x:hidden"
          >載入中…</iframe>
        </div>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="openConsult(true)">取消</el-button>
        </span>
      </template>
    </el-dialog>
    <el-menu
      class="top-menu pc-menu animate__animated animate__faster animate__fadeInDown"
      mode="horizontal"
      background-color="#5C88A1"
      text-color="#fff"
      active-text-color="#ffd04b"
      :router="true"
    >
      <img
        src="@/assets/logo.svg"
        alt="logo"
        style="height:35px;left:15px;position:absolute"
        @click="$router.push('/')"
      >
      <el-menu-item
        index="1"
        route="/news"
      >
        最新消息
      </el-menu-item>
      <el-menu-item
        index="2"
        route="/accident"
      >
        發生車禍
      </el-menu-item>
      <el-menu-item
        index="3"
        route="/procedure"
      >
        處理流程
      </el-menu-item>
      <el-menu-item
        index="4"
        route="/compensation"
      >
        損害賠償
      </el-menu-item>
      <el-menu-item
        index="5"
        route="/safe"
      >
        安全宣導
      </el-menu-item>
      <el-menu-item
        index="6"
        route="/contact"
      >
        聯絡我們
      </el-menu-item>
      <el-menu-item
        index="7"
        route="/documents"
      >
        文件下載
      </el-menu-item>
      <el-menu-item
        v-if="newEditAccessRight"
        index="8"
        route="/newedit"
      >
        文章新增
      </el-menu-item>
      <el-menu-item
        v-if="consultAccessRight"
        class="consult"
        @click="$store.commit('setConsultVisible', true)"
      >
        立即諮詢
      </el-menu-item>
      <el-divider
        direction="vertical"
        style="height: 2em;"
      />
      <div style="margin-right:10px;margin-left:10px">
        <div
          v-if="isLogin"
          style="color:white"
        >
          您好，{{ $store.state.userInfo.user_nickname }}！
        </div>
        <div v-else>
          <el-button
            type="text"
            style="font-size:16px;color:white;margin-right:10px"
            @click="changePage('login')"
          >
            登入
          </el-button>
          <el-button
            plain
            @click="changePage('register')"
          >
            註冊
          </el-button>
        </div>
      </div>
    </el-menu>
    <div
      class="top-menu phone-menu"
      style="background-color:#5C88A1;"
    >
      <img
        src="@/assets/logo.svg"
        alt="logo"
        style="height:35px;left:15px;position:absolute"
        @click="$router.push('/')"
      >

      <mdicon
        name="menu"
        width="60"
        height="60"
        style="color:white"
        @click="drawer = true"
      />
    </div>
    <el-drawer
      v-model="drawer"
      direction="rtl"
      :with-header="false"
      size="80%"
    >
      <mdicon
        name="close"
        width="50"
        height="50"
        style="color:white;position:absolute;z-index:2;right:0px"
        @click="drawer = false"
      />
      <el-menu
        background-color="#5C88A1"
        text-color="#fff"
        active-text-color="#ffd04b"
        :router="true"
      >
        <div
          style="width:100%"
          class="login-status"
        >
          <div v-if="isLogin">
            <el-row :gutter="20">
              <el-col :span="7">
                <el-avatar
                  :size="50"
                  style="margin:10px;margin-right:20px;margin-bottom:5px"
                  icon="el-icon-user-solid"
                />
              </el-col>
              <el-col
                :span="17"
                style="display: flex;justify-content: left;align-items: center;color:white"
              >
                您好，{{ $store.state.userInfo.user_nickname }}！
              </el-col>
            </el-row>
          </div>
          <div v-else>
            <el-row :gutter="20">
              <el-col :span="7">
                <el-avatar
                  :size="50"
                  style="margin:10px;margin-right:20px;margin-bottom:5px"
                  icon="el-icon-user-solid"
                />
              </el-col>
              <el-col
                :span="17"
                style="display: flex;justify-content: left;align-items: center;color:white"
              >
                尚未登入！
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12">
                <el-button
                  plain
                  class="login-reg-btn"
                  @click="changePage('login')"
                >
                  登入
                </el-button>
              </el-col>
              <el-col :span="12">
                <el-button
                  plain
                  class="login-reg-btn"
                  @click="changePage('register')"
                >
                  立即註冊
                </el-button>
              </el-col>
            </el-row>
          </div>
        </div>
        <div style="padding-left:15px;padding-right:15px">
          <el-divider style="width:auto;height:2px;margin:0px;opacity:0.5" />
        </div>
        <el-menu-item
          index="1"
          route="/news"
          @click="drawer = false"
        >
          最新消息
        </el-menu-item>
        <el-menu-item
          index="2"
          route="/accident"
          @click="drawer = false"
        >
          發生車禍
        </el-menu-item>
        <el-menu-item
          index="3"
          route="/procedure"
          @click="drawer = false"
        >
          處理流程
        </el-menu-item>
        <el-menu-item
          index="4"
          route="/compensation"
          @click="drawer = false"
        >
          損害賠償
        </el-menu-item>
        <el-menu-item
          index="5"
          route="/safe"
          @click="drawer = false"
        >
          安全宣導
        </el-menu-item>
        <el-menu-item
          index="6"
          route="/contact"
          @click="drawer = false"
        >
          聯絡我們
        </el-menu-item>
        <el-menu-item
          index="7"
          route="/documents"
          @click="drawer = false"
        >
          文件下載
        </el-menu-item>
        <el-menu-item
          v-if="newEditAccessRight"
          index="8"
          route="/newedit"
          @click="drawer = false"
        >
          文件新增
        </el-menu-item>
        <el-menu-item
          v-if="consultAccessRight"
          class="consult"
          @click="$store.commit('setConsultVisible', true)"
        >
          立即諮詢
        </el-menu-item>
        <div style="padding-left:15px;padding-right:15px">
          <el-divider style="width:auto;height:2px;margin:0px;opacity:0.5" />
        </div>
        <div
          style="color:white;height: 56px;width:100%;  display: flex;justify-content: center;align-items: center;"
          @click="drawer = false"
        >
          返回
        </div>
      </el-menu>
    </el-drawer>
    <div style="min-height:100vh">
      <router-view v-slot="{ Component }">
        <transition name="fade">
          <component :is="Component" />
        </transition>
      </router-view>
    </div>
    <div class="footer">
      <div style="width: 75%;">
        <el-row
          :gutter="20"
          style="width:100%;background-color:rgba(0,0,0,0.1);padding:10px;border-radius:4px"
        >
          <el-col
            :sm="5"
            :xs="24"
          >
            <img
              src="@/assets/logo.svg"
              alt="logo"
            >
          </el-col>
          <el-col
            :sm="5"
            :xs="24"
          >
            <el-link
              :underline="false"
              href="/accident"
            >
              發生車禍
            </el-link><br>
            <el-link
              :underline="false"
              href="/accident/a1"
            >
              警方到場前
            </el-link><br>
            <el-link
              :underline="false"
              href="/accident/b1"
            >
              警方處理中
            </el-link><br><br><br>
            <el-link
              :underline="false"
              href="/safe"
            >
              交通安全宣導
            </el-link>
          </el-col>
          <el-col
            :sm="5"
            :xs="24"
          >
            <el-link
              :underline="false"
              href="/procedure/c1"
            >
              處理流程
            </el-link><br>
            <el-link
              :underline="false"
              href="/procedure/d1"
            >
              交通事故資料申請
            </el-link><br>
            <el-link
              :underline="false"
              href="/procedure/e1"
            >
              車禍鑑定申請
            </el-link><br>
            <el-link
              :underline="false"
              href="/procedure"
            >
              調解申請
            </el-link><br>
            <br>
            <el-link
              :underline="false"
              href="/"
            >
              相關問答
            </el-link>
          </el-col>
          <el-col
            :sm="5"
            :xs="24"
          >
            <el-link
              :underline="false"
              href="/compensation"
            >
              損害賠償
            </el-link><br>
            <el-link
              :underline="false"
              href="/compensation/f1"
            >
              車禍責任
            </el-link> | <el-link
              :underline="false"
              href="/compensation/g1"
            >
              法律扶助
            </el-link><br>
            <el-link
              :underline="false"
              href="/compensation/h1"
            >
              賠償試算
            </el-link> | <el-link
              :underline="false"
              href="/compensation/i1"
            >
              被害人保護
            </el-link><br>
            <el-link
              :underline="false"
              href="/compensation/j1"
            >
              保險理賠
            </el-link> | <el-link
              :underline="false"
              href="/compensation/k1"
            >
              社會福利
            </el-link><br>
            <br>
            <el-link
              :underline="false"
              href="/documents"
            >
              文件下載
            </el-link>
          </el-col>
        </el-row><br>
        <el-descriptions
          title="聯絡我們"
          class="pc-only"
        >
          <el-descriptions-item label="名稱">
            守護神智能科技有限公司
          </el-descriptions-item>
          <el-descriptions-item label="電話號碼">
            07-3852737
          </el-descriptions-item>
          <el-descriptions-item label="手機號碼">
            0936-127554
          </el-descriptions-item>
          <el-descriptions-item label="Email">
            guardian17681@gmail.com
          </el-descriptions-item>
          <el-descriptions-item label="地址">
            807043高雄市九如一路436號3樓
          </el-descriptions-item>
        </el-descriptions>
        <div class="phone-only">
          <div>
            守護神智能科技有限公司
          </div>
          <div>
            07-3852737
          </div>
          <div>
            0936-127554
          </div>
          <div>
            Guardian17681@gmail.com
          </div>
          <div>
            807043高雄市九如一路436號3樓
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
export default {
  name: 'App',
  setup () {
    const drawer = ref(false)
    const router = useRouter()
    const store = useStore()
    function changePage (page) {
      router.push('/' + page)
      drawer.value = false
    }
    const isLogin = computed(() => {
      return store.state.loginState
    })
    const newEditAccessRight = computed(() => {
      return store.state.userInfo.user_level === 'admin'
    })
    const consultAccessRight = computed(() => {
      return store.state.userInfo.user_level === 'guest'
    })
    window.addEventListener('scroll', function () {
      const el = document.getElementsByClassName('pc-menu')[0]
      if (window.scrollY > 150) {
        el.classList.remove('animate__fadeInDown')
        el.classList.add('animate__fadeOutUp')
      } else {
        el.classList.add('animate__fadeInDown')
        el.classList.remove('animate__fadeOutUp')
      }
    })
    return {
      drawer,
      changePage,
      newEditAccessRight,
      consultAccessRight,
      isLogin
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./assets/font.css";
$top-menu-item-size: 16px;
$phones-media: 769px;
.el-link.el-link--default {
  color: rgb(44, 44, 44);
  transition: 150ms;
  font-size: 16px;
  &:hover {
    color: var(--el-color-primary);
    filter: brightness(150%);
    transition: 150ms;
  }
}
.el-link.el-link--primary {
  vertical-align: baseline;
  color: var(--el-color-primary);
  font-size: 14px;
  transition: 150ms;
  &:hover {
    filter: brightness(150%);
    transition: 150ms;
  }
}
#app {
  font-family: "Gen Jyuu Gothic";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #0a1d31;
}
::v-deep .el-descriptions__body {
  background-color: rgba(0, 0, 0, 0);
  color: black;
}
.top-menu {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  filter: drop-shadow(0px 3px 3px rgba(0, 0, 0, 0.7));
  border-bottom: solid 0px;
  position: absolute;
  z-index: 999;
  width: 100%;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
  position: absolute;
  width: 100%;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.el-menu-item {
  font-size: $top-menu-item-size;
}
.el-menu.el-menu--horizontal {
  border: solid 0px;
} // 移除奇怪的menu下底線
.phone-menu-icon {
  transition: 500ms;
  &:hover {
    background-color: rgba(0, 0, 0, 0.25);
    transition: 500ms;
  }
}
.login-reg-btn {
  color: black;
  margin: 5px;
  border-radius: 5px;
  width: calc(100% - 10px);
  height: 20px;
}
@media only screen and (max-width: $phones-media) {
  //手機版css
  .pc-menu {
    display: none;
  }
  .phone-menu {
    display: "";
  }
  .el-menu-item {
    text-align: center;
    font-size: 14px;
    height: 48px;
  }
  ::v-deep .el-drawer__body {
    //手機側邊抽屜選單
    background-color: #5c88a0;
  }
  .footer {
    background-color: #7da7be;
    width: 100%;
    min-height: 350px;
    display: flex;
    justify-content: center;
    padding: 15px 0px;
    align-items: center;
  }
  .el-row {
    margin: 0px !important;
  }
  .phone-only {
    display: default;
    div {
      margin: 5px 0px;
    }
  }
  .pc-only {
    display: none;
  }
}
@media only screen and (min-width: $phones-media) {
  //電腦版css
  .phone-menu {
    display: none;
  }
  .pc-menu {
    position: fixed;
  }
  ::v-deep .el-dialog.is-fullscreen {
    width: 40%;
    margin-top: 2.5%;
    margin-bottom: 0;
    height: 90%;
    overflow: auto;
  }
  .member-icon {
    transition: 500ms;
    &:hover {
      filter: brightness(0.75);
      transition: 500ms;
    }
  }
  .footer {
    background-color: #7da7be;
    width: 100%;
    min-height: 350px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .consult {
    transition: 500ms;
    color: #a1e4ff !important;
    &:hover {
      transition: 500ms;
    }
  }
  .phone-only {
    display: none;
  }
  .pc-only {
    display: default;
  }
}
</style>
<style lang="scss">
.el-button--primary {
  --el-button-background-color: #5d88a1 !important;
  --el-button-border-color: #5d88a1 !important;
}
$phones-media: 769px;
@media only screen and (max-width: $phones-media) {
  .el-message.el-message--success {
    min-width: 100vw !important;
    top: 5px !important;
  }
  .el-message.el-message--error {
    min-width: 100vw !important;
    top: 5px !important;
  }
}
</style>
